/**
 * @fileoverview Device token registration mutation hook.
 * @description Wraps the register-device-token API call in a TanStack mutation for loading/error
 * state.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useMutation } from '@tanstack/react-query'

import {
  registerDeviceToken,
  type RegisterDeviceTokenRequest,
} from '@/features/notifications/services/notifications.service'

import type { ApiError } from '@/shared/types/http.types'

/**
 * @description Registers the current browser's FCM device token with the backend.
 * @returns {ReturnType<typeof useMutation<void, ApiError, RegisterDeviceTokenRequest>>} The
 * mutation object (mutate, isPending, error, ...).
 */
export function useRegisterDeviceToken() {
  return useMutation<void, ApiError, RegisterDeviceTokenRequest>({
    mutationFn: registerDeviceToken,
  })
}
